import React, { useEffect, useRef, useState } from 'react';
import { ConstructorEventUpdateSQLStatus} from '../../../Event/event';

const QuickShoppingList = () => {
  const [prices, setPrices] = useState([]);
  const [estimate, setEstimate] = useState('');
  const [feedback, setFeedback] = useState('');
  const [feedbackClass, setFeedbackClass] = useState('');
  const [showNewBtn, setShowNewBtn] = useState(false);

  const inputRef = useRef();

  const generatePrices = () => {
    const newPrices = Array.from({ length: 5 }, () =>
      parseFloat((Math.random() * 9 + 1).toFixed(2))
    );
    setPrices(newPrices);
    setEstimate('');
    setFeedback('');
    setFeedbackClass('');
    setShowNewBtn(false);
    setTimeout(() => inputRef.current?.focus(), 100);
  };

  const getEstimatedTotal = () => {
    return prices.reduce((sum, price) => sum + Math.round(price), 0);
  };

  const checkAnswer = () => {
    if (estimate.trim() === '') {
      setFeedback('Please enter your estimated total.');
      setFeedbackClass('incorrect');
      return;
    }

    const userVal = parseInt(estimate, 10);
    const correct = getEstimatedTotal();

    if (userVal === correct) {
      setFeedback(`🎉 Great job! Your estimate is correct: $${correct}`);
                  const responsedata = ConstructorEventUpdateSQLStatus();
      console.log("Event completed", responsedata);
      setFeedbackClass('correct');
      setShowNewBtn(true);
    } else {
      setFeedback('🙈 Oops! Try again.');
      setFeedbackClass('incorrect');
    }
  };

  useEffect(() => {
    generatePrices();
  }, []);

  const styles = {
    body: {
      margin: 0,
      fontFamily: "'Comic Sans MS', cursive, sans-serif",
      background: 'linear-gradient(135deg, #fbc2eb, #a6c1ee)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      padding: '1rem',
      boxSizing: 'border-box',
    },
    game: {
      background: '#fff',
      borderRadius: '20px',
      boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
      padding: '2rem',
      width: '100%',
      maxWidth: '400px',
      textAlign: 'center',
    },
    h1: {
      color: '#6a1b9a',
      marginBottom: '1rem',
      fontSize: '1.8rem',
    },
    ul: {
      listStyle: 'none',
      padding: 0,
      marginBottom: '1.5rem',
      display: 'flex',
      flexDirection: 'column',
      gap: '0.5rem',
    },
    li: {
      fontSize: '1.3rem',
      color: '#4a148c',
    },
    question: {
      fontSize: '1.1rem',
      marginBottom: '0.8rem',
      color: '#333',
    },
    input: {
      fontSize: '1.3rem',
      padding: '0.6rem 1rem',
      border: '3px solid #6a1b9a',
      borderRadius: '10px',
      textAlign: 'center',
      width: '100%',
      maxWidth: '400px',
      marginBottom: '1rem',
    },
    button: {
      fontSize: '1rem',
      padding: '0.6rem 1.2rem',
      border: 'none',
      background: '#6a1b9a',
      color: '#fff',
      borderRadius: '25px',
      cursor: 'pointer',
      margin: '0.5rem',
      width: 'fit-content',
    },
    feedback: {
      fontSize: '1.2rem',
      marginTop: '1rem',
      minHeight: '40px',
    },
    correct: {
      color: '#2e7d32',
    },
    incorrect: {
      color: '#d32f2f',
    },
  };

  return (
    <div style={styles.body}>
      <div style={styles.game} role="main" aria-label="Quick Shopping List game">
        <h2 style={styles.h1}>🛒 Quick Shopping List</h2>

        <ul style={styles.ul} aria-live="polite">
          {prices.map((p, i) => (
            <li key={i} style={styles.li}>
              Item {i + 1}: ${p.toFixed(2)}
            </li>
          ))}
        </ul>

        <div style={styles.question}>
          Estimate the total by rounding each item to the nearest dollar.
        </div>

        <input
          type="number"
          ref={inputRef}
          value={estimate}
          onChange={(e) => setEstimate(e.target.value)}
          placeholder="$0"
          style={styles.input}
          onKeyDown={(e) => e.key === 'Enter' && checkAnswer()}
          aria-label="Your estimate"
          disabled={showNewBtn}
        />

        <br />

        {!showNewBtn ? (
          <button style={styles.button} onClick={checkAnswer}>
            Check
          </button>
        ) : (
          <button style={styles.button} onClick={generatePrices}>
            Try Another List
          </button>
        )}

        <div
          style={{
            ...styles.feedback,
            ...(feedbackClass === 'correct'
              ? styles.correct
              : feedbackClass === 'incorrect'
              ? styles.incorrect
              : {}),
          }}
          role="alert"
          aria-live="assertive"
        >
          {feedback}
        </div>
      </div>
    </div>
  );
};

export default QuickShoppingList;
